export default __webpack_public_path__ + "static/media/monitor-o.307c07e7.svg";